import React from 'react'
import './thanks.css'
import { useNavigate } from 'react-router-dom';

function Thankyou() {
    const navigate = useNavigate();
    return (
        <div className='thanksmaindiv'>
            <h3>Thank You for Your Submission!</h3>
            <p>Your message has been received successfully. We'll get back to you shortly.</p>
            <button className='thanksbtn' onClick={() => navigate('/')}>Go to Home</button>
        </div>
    )
}

export default Thankyou
